import { React, useState, useEffect } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { Autocomplete, Modal, TextField } from "@mui/material";

const ModalAgregarCliente = ({ open, onClose, usuario, cargar }) => {
    const [clienteslist, setClienteList] = useState([]);
    const [clienteselect, setClienteSelect] = useState("");
    const [cliente, setCliente] = useState("")

    const [mostrarModal, setMostrarModal] = useState(false);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        request
            .get("Clientes/DropDownList")
            .then((result) => {
                setClienteList(result);
            })
            .catch((error) => {
                Swal.fire("REFERENCIAS BANCARIAS", JSON.stringify(error), "error");
            });
    }, []);

    const onLigar = (idcliente) => {
        if (
            idcliente === undefined ||
            idcliente === null ||
            idcliente === ""
        ) {
            Swal.fire(
                "Clientes",
                "Favor de seleccionar un cliente",
                "error"
            );
            return;
        }
        if (
            usuario.idSucursal === undefined ||
            usuario.idSucursal === null ||
            usuario.idSucursal === ""
        ) {
            Swal.fire(
                "Clientes",
                "Cliente sin sucursal",
                "error"
            );
            return;
        }
        const post = {
            idcliente: idcliente,
            idequip: usuario.idCliente,
            sucursal: usuario.idSucursal,
        };
        request
            .post("ClientesEQUIP", post)
            .then((result) => {
                Swal.fire(
                    "Clientes",
                    "Cliente ligado correctamente",
                    "success"
                );
                setCliente("")
                setClienteSelect("")
                onClose();
                cargar()
            })
            .catch((error) => {
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onRegistrar = () => {
        var result = {
            razon_social: usuario.razonSocial,
            rfc: "XAXX010101000",
            tipo_persona: "M",
            medio_contacto: "LL",
            tiempo_agricultor: 1,
            regimen_fiscal: "626",
            referencia: "",
            agrupacion: "I",
            tipo_venta: "CR",
            idvendedor: "4324",
            idcliente: "-1",
        };
        if (result === undefined || result === null || result === false) return;

        setLoader(true);

        if (
            result.razon_social === undefined ||
            result.razon_social === null ||
            result.razon_social === ""
        ) {
            Swal.fire("Clientes", "El campo Razón Social es Obligatorio", "warning");
            setLoader(false);
            return false;
        }

        if (
            result.idvendedor === undefined ||
            result.idvendedor === null ||
            result.idvendedor === ""
        ) {
            Swal.fire(
                "Clientes",
                "Seleccione un vendedor para el cliente",
                "warning"
            );
            setLoader(false);
            return false;
        }
        const endpoint =
            result.tipo_persona === "M"
                ? "Clientes/Persona_Moral_Vendedor"
                : "Clientes/Persona_Fisica";

        request
            .post(endpoint, result)
            .then(async (result) => {
                setLoader(false);
                onLigar(result)
            })
            .catch(async (error) => {
                setLoader(false);
                await Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onCerrar = () => {
        setCliente("")
        setClienteSelect("")
        onClose()
    };


    return (
        <>
            <LoaderScreen loader={loader} />
            <Modal open={open} onClose={onClose}>
                <div className="modal-agregar-cliente-main-container">
                    <div className="generar-convenio-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"AGREGAR CLIENTE"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onCerrar}>X</div>
                                <div className={`generar-convenio-modal-agregar-convenio`}>
                                    <div style={{ marginBottom: 20, marginTop: 20, marginLeft: 10, marginRight: 10 }}>
                                        <Autocomplete
                                            size="small"
                                            id="dash-razonsocial"
                                            freeSolo
                                            className="reestructurar-credito-buscar-cliente-autocomplete"
                                            value={clienteselect}
                                            onChange={(event, value) => {
                                                setClienteSelect(value);          // value es "123 - Razón Social"
                                                setCliente(value?.split(" - ")[0] || ""); // extrae idcliente
                                            }}
                                            options={clienteslist.map(option => `${option.id} - ${option.display}`)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="SELECCIONAR CLIENTE"
                                                />
                                            )}
                                        />
                                    </div>

                                    <div className="modal-agregar-cliente-buttons">
                                        <div
                                            className="modal-button-registrar-asd"
                                            onClick={() => onRegistrar()}
                                        >
                                            Registrar
                                        </div>
                                        <button
                                            className="generar-convenio-modal-button-guardar"
                                            onClick={() => onLigar(cliente)}
                                        >
                                            Ligar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default ModalAgregarCliente;